import { Component, Input, OnInit } from '@angular/core';
import { Territory } from 'src/app/models/territory';
import { TerritoryService } from 'src/app/services/territory.service';

@Component({
  selector: 'app-trademark-country',
  templateUrl: './trademark-country.component.html',
  styleUrls: ['./trademark-country.component.scss']
})
export class TrademarkCountryComponent implements OnInit {
  @Input() wipoCode?: string;
  @Input() displayMode: 'flag' | 'name' | 'full' = 'flag';
  territory?: Territory;

  constructor(
    private readonly territoryService: TerritoryService
  ) {
  }

  ngOnInit(): void {
    this.retrieveTerritories();
  }

  async retrieveTerritories() {
    await this.territoryService.retrieve();
    this.territory = this.wipoCode
      ? this.territoryService.retrieveOne(this.wipoCode.toUpperCase())
      : undefined;
  }
}
